// pages/LuxotticaLoginPage.jsx (or any page file)

import LoginPage from '@/components/LoginPage';
import config from '@/config';
import { buildPath } from '@/utils/routeBuilder';

const LuxotticaLoginPage = () => {
  return (
    <LoginPage
      projectId="luxottica"
      projectName="Luxottica"
      registerPath={buildPath('/luxottica/register')}
      forgotPasswordPath={buildPath('/luxottica/forgot-password')}
      dashboardPath={buildPath('/luxottica')}
      apiUrl={config.AUTH_API_ADDRESS}
      brandColor="blue"
    />
  );
};

export default LuxotticaLoginPage;